/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object,
    shape,
    arrayOf,
    string,
} from 'prop-types';
import { useUIDSeed } from 'react-uid';

const styles = (theme) => ({
    container: {
        width: '100%',
        fontFamily: 'Roboto, serif',
        padding: '16px',
        lineHeight: '20px',
        borderTop: `${theme.palette.desktopHeaderMenu.border}`,
        fontSize: '14px',
        textShadow: '1px 1px 1px rgba(0, 0, 0, 0.004)',
        letterSpacing: '0.03em',
        textRendering: 'optimizeLegibility',
    },
    heading: {
        fontSize: '24px',
        textAlign: 'center',
        width: '100%',
    },
    content: {
        margin: '0 auto',
        textAlign: 'center',
        '& h4': {
            margin: '16px 0',
            textAlign: 'center',
            width: '100%',
            fontSize: '20px',
            fontWeight: '500',
        },
        '& p': {
            fontSize: '14px',
            textShadow: '1px 1px 1px rgba(0, 0, 0, 0.004)',
            letterSpacing: '0.03em',
            textRendering: 'optimizeLegibility',
            whiteSpace: 'pre-wrap',
        },
        '& a': {
            color: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
            cursor: 'pointer',
            textDecoration: 'underline',
            marginRight: '-4px',
        },
    },

    articleWrapper: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        boxWizing: 'border-box',
        alignContent: 'space-between',
    },
    articleContainer: {
        padding: '8px',
        flexGrow: '1',
        maxWidth: '100%',
        flexBasis: '0',
    },
    articleLink: {
        cursor: 'pointer',
        userSelect: 'none',
        color: `${theme.palette.common.black}`,
        textAlign: 'center',
        textDecoration: 'none',
    },
    articleImageContainer: {
        display: 'flex',
        position: 'relative',
        minWidth: '1px',
        minHeight: '1px',
        alignItems: 'center',
        justifyContent: 'center',
    },
    articleHeading: {
        marginTop: '8px',
        display: 'block',
        whiteSpace: 'pre-wrap',
        fontSize: '14px',
        textShadow: '1px 1px 1px rgba(0, 0, 0, 0.004)',
        letterSpacing: '0.03em',
        textRendering: 'optimizeLegibility',
    },
    center: {
        textAlign: 'center',
    },
    letterSpacing: {
        letterSpacing: '0.42px',
    },
    contentSubHeading: {
        textAlign: 'center',
        letterSpacing: '0.42px',
    },
});

const mapMultiDescription = (item, classes) => {
    const seed = useUIDSeed();
    if (item.image_url) {
        return (
            <div className={classes.content} key={seed(item)}>
                <img className={classes.bannerImg} src={item.image_url} alt="Sympathy Banner" />
            </div>
        );
    }
    if (item.center) {
        if (item.italic) {
            return (
                <p key={seed(item)} className={classes.contentSubHeading}>
                    <i><strong>{item.strong}</strong></i>
                </p>
            );
        }
        return (
            <div key={seed(item)} className={classes.center}>
                <strong>{item.strong}</strong>
            </div>
        );
    }
    if (item.strong && item.list) {
        return (
            <div key={seed(item)}>
                <strong>{item.strong}</strong>
                <ol>
                    {item.list.map((listItem) => (<li key={seed(listItem)}><strong>{listItem.strong}</strong>{listItem.content}</li>))}
                </ol>
            </div>
        );
    }
    return (
        <p key={seed(item)}>
            {item.content}
        </p>
    );
};

const SympathyArticleGoodListenerBlock = (props) => {
    const {
        data: {
            heading,
            multi_description,
        },
        classes,
    } = props;
    return (
        <>
            <div className={classes.container}>
                <div className={classes.heading}>{heading}</div>
                <div className={classes.content}>
                    {multi_description.map((item) => mapMultiDescription(item, classes))}
                </div>
            </div>
        </>
    );
};

SympathyArticleGoodListenerBlock.propTypes = {
    classes: object.isRequired,
    data: shape({
        heading: string.isRequired,
        multi_description: arrayOf(
            shape({
                content: string,
            }),
        ),
    }).isRequired,
};
export default withStyles(styles)(SympathyArticleGoodListenerBlock);
